import { BillingMetrics } from '../../../shared/BillingMetrics';

interface DailyMetricConsumption {
  metricId: string;
  total: number;
}

interface AiTokenDailyConsumptionRaw {
  dateReference: string;
  metricConsumption: DailyMetricConsumption[];
}

export class AiTokenDailyConsumption {
  dateReference!: string;
  aiToken!: number;

  constructor(raw: AiTokenDailyConsumptionRaw) {
    this.dateReference = raw.dateReference;
    this.aiToken = raw.metricConsumption.find((mc) => mc.metricId === BillingMetrics.aiToken)?.total ?? 0;
  }
}
